import BaseAPI, { URLS } from './BaseAPI';

class BranchesAPI {
  static async getList(params) {
    try {
      const response = await BaseAPI.get(URLS.SIZES, params);
      return response.status === 200
        ? response.data
        : { error: 'Falha ao carregar a lista de tamanhos' };
    } catch (e) {
      console.log(e.message);
      return { error: 'Falha ao carregar a lista de tamanhos' };
    }
  }

  static async save(data) {
    try {
      const response = await BaseAPI.post(URLS.SIZES, data);
      return response.status === 201
        ? response.data
        : { error: 'Falha ao salvar tamanho' };
    } catch (e) {
      return {
        error: e?.response?.data?.message
          ? e?.response?.data?.message
          : 'Falha ao salvar tamanho',
      };
    }
  }

  static async update(uuid, data) {
    try {
      const response = await BaseAPI.put(`${URLS.SIZES}/${uuid}`, data);
      return response.status === 200
        ? response.data
        : { error: 'Falha ao atualizar tamanho' };
    } catch (e) {
      return {
        error: e?.response?.data?.message
          ? e?.response?.data?.message
          : 'Falha ao salvar tamanho',
      };
    }
  }

  static async get(uuid) {
    try {
      const response = await BaseAPI.get(`${URLS.SIZES}/${uuid}`);
      return response.status === 200
        ? response.data
        : { error: 'Falha ao carregar tamanho' };
    } catch (e) {
      console.log(e.message);
      return { error: 'Falha ao carregar tamanho' };
    }
  }

  static async delete(uuid) {
    try {
      const response = await BaseAPI.delete(`${URLS.SIZES}/${uuid}`);
      return response.status === 204
        ? response.data
        : { error: 'Falha ao deletar tamanho' };
    } catch (e) {
      console.log(e.message);
      return { error: 'Falha ao deletar tamanho' };
    }
  }
}

export default BranchesAPI;
